// extracted by mini-css-extract-plugin
export default {"productGrid":"hY-z","centerLink":"iY-z","productSection":"jY-z","item":"kY-z","ctaButton":"lY-z"};